import { useGameStore } from '../stores/gameStore'
import { useShangGameStore } from '../stores/shangGameStore'
import './CityPanel.css'

export function CityPanel() {
  const { 
    resources, 
    resourceIncome, 
    buildings, 
    populationAllocation, 
    upgradeBuilding,
    setPopulationAllocation,
    setView
  } = useGameStore()

  // 获取当前势力的国都名称
  const capitalName = useShangGameStore((state) => state.getPlayerCapitalName())

  const buildingIcons: Record<string, string> = {
    farm: '🌾',
    market: '💰',
    house: '🏠',
    academy: '📚',
  }

  const buildingDescriptions: Record<string, string> = {
    farm: '生产粮食',
    market: '产生税收',
    house: '增加人口上限',
    academy: '吸引人才',
  }

  const handleBuild = (buildingId: string) => {
    const success = upgradeBuilding(buildingId)
    if (!success) {
      alert('金钱不足或已达到最高等级')
    }
  }

  const handleAllocationChange = (type: keyof typeof populationAllocation, value: number) => {
    setPopulationAllocation({ [type]: value })
  }

  const idlePopulation = 100 - populationAllocation.farming - populationAllocation.commerce - populationAllocation.construction

  return (
    <div className="city-panel">
      <div className="panel-header">
        <h2 className="panel-title">{capitalName}</h2>
        <button 
          className="manage-cities-btn"
          onClick={() => setView('city-management')}
        >
          🏛 管理城池
        </button>
      </div>
      
      <div className="city-stats">
        <div className="stat-card">
          <span className="stat-label">人口</span>
          <span className="stat-value">{Math.floor(resources.population)}/500</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">民心</span>
          <span className="stat-value">80/100</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">治安</span>
          <span className="stat-value">75/100</span>
        </div>
      </div>

      <div className="income-summary">
        <h3>每月收入</h3>
        <div className="income-items">
          <div className="income-item">
            <span className="income-icon">🌾</span>
            <span className="income-value">+{resourceIncome.food.toFixed(1)}</span>
          </div>
          <div className="income-item">
            <span className="income-icon">💰</span>
            <span className="income-value">+{resourceIncome.money.toFixed(1)}</span>
          </div>
          <div className="income-item">
            <span className="income-icon">👥</span>
            <span className="income-value">+{resourceIncome.population.toFixed(1)}</span>
          </div>
        </div>
      </div>

      <div className="buildings-section">
        <h3>城内建筑</h3>
        <div className="buildings-grid">
          {buildings.map((building) => (
            <div key={building.id} className="building-card">
              <div className="building-header">
                <span className="building-icon">{buildingIcons[building.id]}</span>
                <div className="building-info">
                  <span className="building-name">{building.name}</span>
                  <span className="building-level">等级 {building.level}/{building.maxLevel}</span>
                </div>
              </div>
              <p className="building-desc">{buildingDescriptions[building.id]}</p>
              <div className="building-output">
                <span>产出: +{building.output}/月</span>
              </div>
              <button 
                className="build-btn"
                onClick={() => handleBuild(building.id)}
                disabled={building.level >= building.maxLevel}
              >
                {building.level === 0 ? '建造' : '升级'}
                {building.level > 0 && building.level < building.maxLevel && ` (${building.level * 100}金)`}
                {building.level >= building.maxLevel && ' (已满级)'}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="population-section">
        <h3>人口分配</h3>
        <div className="population-bars">
          <div className="pop-bar">
            <span className="pop-label">农业</span>
            <input
              type="range"
              min="0"
              max="100"
              value={populationAllocation.farming}
              onChange={(e) => handleAllocationChange('farming', parseInt(e.target.value))}
              className="pop-slider"
            />
            <span className="pop-value">{populationAllocation.farming}%</span>
          </div>
          <div className="pop-bar">
            <span className="pop-label">商业</span>
            <input
              type="range"
              min="0"
              max="100"
              value={populationAllocation.commerce}
              onChange={(e) => handleAllocationChange('commerce', parseInt(e.target.value))}
              className="pop-slider"
            />
            <span className="pop-value">{populationAllocation.commerce}%</span>
          </div>
          <div className="pop-bar">
            <span className="pop-label">建设</span>
            <input
              type="range"
              min="0"
              max="100"
              value={populationAllocation.construction}
              onChange={(e) => handleAllocationChange('construction', parseInt(e.target.value))}
              className="pop-slider"
            />
            <span className="pop-value">{populationAllocation.construction}%</span>
          </div>
          <div className="pop-bar">
            <span className="pop-label">闲置</span>
            <div className="pop-track">
              <div className="pop-fill idle" style={{ width: `${idlePopulation}%` }}></div>
            </div>
            <span className="pop-value">{idlePopulation}%</span>
          </div>
        </div>
      </div>
    </div>
  )
}
